import { Checkbox } from "@/core/components/ui/checkbox";
import type { WorkbookExportSheet } from "./types";

interface WorkbookSheetSelectionProps {
  sheets: WorkbookExportSheet[];
  selectedIds: string[];
  disabled: boolean;
  onChange: (ids: string[]) => void;
}

export const WorkbookSheetSelection = ({
  sheets,
  selectedIds,
  disabled,
  onChange,
}: WorkbookSheetSelectionProps) => {
  const selectedIdSet = new Set(selectedIds);
  return (
    <>
      <div className="flex items-center justify-between">
        <label className="flex items-center gap-2">
          <Checkbox
            checked={sheets.length > 0 && selectedIds.length === sheets.length}
            indeterminate={
              selectedIds.length > 0 && selectedIds.length < sheets.length
            }
            disabled={disabled || sheets.length === 0}
            onCheckedChange={(checked) =>
              onChange(checked ? sheets.map((sheet) => sheet.id) : [])
            }
          />
          Select all
        </label>
        <span className="text-secondary-text">
          {selectedIds.length} of {sheets.length} selected
        </span>
      </div>
      <div className="max-h-64 overflow-y-auto rounded-md border border-stroke-secondary p-2">
        {sheets.length === 0 && (
          <p className="p-2">
            No sheets are available. Close this dialog and refresh the Grid.
          </p>
        )}
        {sheets.map((sheet) => (
          <label
            key={sheet.id}
            className="flex min-h-8 items-center gap-2 px-1"
          >
            <Checkbox
              checked={selectedIdSet.has(sheet.id)}
              disabled={disabled}
              onCheckedChange={(checked) =>
                onChange(
                  checked
                    ? [...selectedIds, sheet.id]
                    : selectedIds.filter((id) => id !== sheet.id),
                )
              }
            />
            <span className="min-w-0 break-words">{sheet.name}</span>
          </label>
        ))}
      </div>
    </>
  );
};
